export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/upcoming-occasion-mascot-4b6150567d8f2be13bce2cd11fc80819.png";